module.exports = __webpack_public_path__ + "img/4.5334e6de.png";